import React, { Fragment } from "react";
import { Route } from "react-router-dom";

import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import AppFooter from "../../Layout/AppFooter";
import Exportar from "./Exportar";

const Administracion = ({ match }) => (
    <Fragment>
        <AppHeader />
        <div className="app-main">
            <AppSidebar />
            <div className="app-main__outer">
                <div className="app-main__inner">

                    {/* ADMIN */}
                    <Route path={`${match.url}/exportar`} component={Exportar} />
                </div>
                <AppFooter />
            </div>
        </div>
    </Fragment>
);

export default Administracion;



// WEBPACK FOOTER //
// src/Pages/Administracion/index.js